import {Scanner} from "@yudiel/react-qr-scanner";
import React, {Component} from "react";
import FlexView from "react-flexview";
import Button from "../../../../../modules/commons/Button";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import Api from "../../../../../Services/Api";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import MutasiBarangDetailPilihUnit from "./mutasiBarangDetailPilihUnit/mutasiBarangDetailPilihUnit";
import * as R from "ramda";
import {mapToObjectDDL} from "../../../../common/mapper";
import {ACTIVITY_TYPE, HttpStatus} from "../../../../common/Constants";
import { defaultTableChange } from "../../../../../modules/custom/customTable";

class MutasiBarangDetailTabUnit extends Component {
    tableColumns = [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, {rowIndex}) =>
                    <p className={this.props.state.data.mutationUnits[rowIndex].status === "REJECTED" ? "color-red" : "color-black"}>
                        {rowIndex + 1}
                    </p>,
                setCellProps: () => ({
                    style: {width: "5%"},
                }),
            },
        },
        {
            name: "kodeVariant",
            options: {
                customHeadRender: (props) => (
                    <th key={props.index} className="custom-locator padding-right-15px">
                        <p style={{display: "flex"}}>
                            {this.props.mutasiKeluarTab ? (
                                <>
                                    Kode Varian<span style={{color: "red"}}>*</span>
                                </>
                            ) : (
                                "Kode Varian"
                            )}
                        </p>
                    </th>
                ),
                customBodyRender: (val, {rowIndex}) => (
                    <>
                        {this.props.mutasiKeluarTab ? (
                            <SimpleDDL
                                id="select_options_kode_varian"
                                name="kodeVariant"
                                box="search"
                                styles={{
                                    menu: (provided) => ({
                                        ...provided,
                                        position: "relative",
                                        fontFamily: "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                                    }),
                                }}
                                containerclassname="margin-bottom-none"
                                readOnly={this.props.state.data.mutationUnits[rowIndex].saved}
                                options={this.props.state.kodeVarianOptions}
                                value={val}
                                onChange={(value, {name}) => {
                                    this.handleVariantChange(rowIndex, name, value)
                                    this.checkUnitOnLocator(value)
                                }}
                            />
                        ) : (
                            <p className={this.props.state.data.mutationUnits[rowIndex].status === "REJECTED" ? "color-red" : "color-black"}>
                                {val.label}
                            </p>
                        )}
                    </>
                ),
                setCellProps: () => ({
                    style: {width: "150px"},
                }),
            },
        },
        {
            name: "variantName",
            label: "Nama Varian",
            options: {
                customBodyRender: (val, {rowIndex}) => (
                    <p className={this.props.state.data.mutationUnits[rowIndex].status === "REJECTED" ? "color-red" : "color-black"}>
                        {val}
                    </p>
                ),
                setCellProps: () => ({
                    style: {width: "200px"},
                }),
            }
        },
        {
            name: "kodeWarna",
            options: {
                customHeadRender: (props) => (
                    <th key={props.index} className="custom-locator padding-right-15px">
                        <p style={{display: "flex"}}>
                            {this.props.mutasiKeluarTab ? (
                                <>
                                    Warna<span style={{color: "red"}}>*</span>
                                </>
                            ) : (
                                "Warna"
                            )}
                        </p>
                    </th>
                ),
                customBodyRender: (val, {rowIndex}) => {
                    let warnaOptions = this.getWarnaOptions(rowIndex)
                    return (
                        <>
                            {this.props.mutasiKeluarTab ? (
                                <SimpleDDL
                                    id="select_options_warna"
                                    name="kodeWarna"
                                    box="search"
                                    styles={{
                                        menu: (provided) => ({
                                            ...provided,
                                            position: "relative",
                                            fontFamily: "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                                        }),
                                    }}
                                    readOnly={this.props.state.data.mutationUnits[rowIndex].saved}
                                    containerclassname="margin-bottom-none"
                                    value={val}
                                    options={warnaOptions}
                                    onChange={(value, {name}) => this.handleValueChange(rowIndex, name, value)}
                                />
                            ) : (
                                <p className={this.props.state.data.mutationUnits[rowIndex].status === "REJECTED" ? "color-red" : "color-black"}>
                                    {val.label}
                                </p>
                            )}
                        </>
                    )
                },
                setCellProps: () => ({
                    style: {width: "250px"},
                }),
            },
        },
        {
            name: "nosin",
            options: {
                customHeadRender: (props) => (
                    <th key={props.index} className="custom-locator padding-right-15px">
                        <p style={{display: "flex"}}>
                            {this.props.mutasiKeluarTab ? (
                                <>
                                    Nosin<span style={{color: "red"}}>*</span>
                                </>
                            ) : (
                                "Nosin"
                            )}
                        </p>
                    </th>
                ),
                customBodyRender: (val, {rowIndex}) => (
                    <>
                        {val === null ?
                            <SimpleButton secondary onClick={() => this.handlePilihUnit(rowIndex, true)}>
                                ...
                            </SimpleButton>
                            :
                            <p style={this.props.state.data.mutationUnits[rowIndex].status === "REJECTED" ? {color: "red"} : {color: "black"}}>
                                {val}
                            </p>}
                    </>
                ),
                setCellProps: () => ({
                    style: {width: "200px"},
                }),
            },
        },
        {
            name: "noka",
            label: "Noka",
            options: {
                customBodyRender: (val, {rowIndex}) => (
                    <p className={this.props.state.data.mutationUnits[rowIndex].status === "REJECTED" ? "color-red" : "color-black"}>
                        {val}
                    </p>
                ),
                setCellProps: () => ({
                    style: {width: "200px"},
                }),
            }
        },
    ];

    constructor(props) {
        super(props);
        this.tableColumns.push({
            name: `${this.props.mutasiKeluarTab ? "saved" : "status"}`,
            label: "Aksi",
            options: {
                customBodyRender: (val, {rowIndex}) => {
                    return this.addUnitDetailButton(val, rowIndex)
                },
                setCellProps: () => ({
                    style: {width: "5%"},
                }),
            },
        });
        this.state = {
            scannerVisible: false,
            noLocator: false,
            pilihUnit: false,
            indexUnit: null,
            isSingleSelectUnit: false,
            alertVariantDoesntExist: false,
            pagination: {
                page: 1,
                limit: 5,
                totalData: 0,
            },
        };
    }

    handleChecked = (index) => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            data: {
                ...prevValue.data,
                mutationUnits: prevValue.data.mutationUnits.map((u, idx) =>
                    idx === index
                        ? {
                            ...u,
                            status: "RECEIVED",
                            checked: !u.checked
                        }
                        : u
                ),
            },
        }));
    };

    handleValueChange = (index, name, value) => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            data: {
                ...prevValue.data,
                mutationUnits: prevValue.data.mutationUnits.map((u, idx) =>
                    idx === index
                        ? {
                            ...u,
                            [name]: value,
                            noka: null,
                            nosin: null
                        }
                        : u
                ),
            },
        }));
    };

    handleVariantChange = async (index, name, value) => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            data: {
                ...prevValue.data,
                mutationUnits: prevValue.data.mutationUnits.map((u, idx) =>
                    idx === index
                        ? {
                            ...u,
                            [name]: value,
                            kodeWarna: null,
                            ...(name === "kodeVariant"
                                ? {variantName: value.namaVariant, noka: value.noka, nosin: value.nosin}
                                : {}),
                        }
                        : u
                ),
            },
        }));

    }

    handlePilihUnit = (index, isSingleSelect) => {
        console.log(isSingleSelect);
        
        this.setState((prevValue) => ({
            ...prevValue,
            pilihUnit: !prevValue.pilihUnit,
            isSingleSelectUnit: isSingleSelect,
            indexUnit: index,
        }))
    }

    handleChosenSingleUnit = (data) => {
        let obj = this.props.state.data.mutationUnits.filter((a, idx) => {
            if (idx === this.state.indexUnit) {
                a.nosin = data.nosin;
                a.noka = data.noka;
                a.kodeWarna = {value: data.idWarna, label: data.namaWarnaKomersil};
                a.idWarna = data.idWarna;
                a.saved = true;
                a.scanned = false;
                a.variantName = data.namaVariant;
                a.kodeVariant = {
                    value: data.kodeVariant,
                    label: data.kodeVariant,
                    noka: data.noka,
                    nosin: data.nosin,
                    namaVariant: data.namaVariant
                };
            }
            return a;
        });
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            data: {
                ...prevValue.data,
                mutationUnits: obj,
            },
        }));
        this.handlePilihUnit();
    }

    handleChosenUnit = (data) => {
        if(this.state.isSingleSelectUnit){
            this.handleChosenSingleUnit(data)
            return
        }
        const transofrmedData = data.map(item=>({
            ...item,
            kodeWarna:{value: item.idWarna, label: item.namaWarnaKomersil},
            saved: true,
            scaned: false,
            variantName: item.namaVariant,
            kodeVariant : {
                value: item.kodeVariant,
                label: item.kodeVariant,
                noka: item.noka,
                nosin: item.nosin,
                namaVariant: item.namaVariant
            }
        }))
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            data: {
                ...prevValue.data,
                mutationUnits: [
                    ...(prevValue.data.mutationUnits || []),
                    ...transofrmedData,
                ],
            },
        }));
        this.handlePilihUnit();
    }

    handleAddUnit = () => {
        if (this.props.state.data.mutationSourceKodeLocator !== null) {
            this.handlePilihUnit()
        } else {
            this.handleTriggerNoLocator();
        }
    };

    handleTriggerNoLocator = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            noLocator: !prevValue.noLocator
        }))
    }

    addUnitViaScanner = () => {
        if (this.props.state.data.mutationSourceKodeLocator !== null) {
            this.handleShowScanner()
        } else {
            this.handleTriggerNoLocator();
        }
    }

    handleSaveRow = (index) => {
        const data = this.props?.state?.data?.mutationUnits[index] || {};
        if(!data.saved){
            const isAlreadyExist = this.props?.state?.data?.mutationUnits?.find(item => item.saved && item?.nosin === data?.nosin)
            
            if(isAlreadyExist){
                this.props.onSetState((prev) => ({
                    ...prev,
                    alertVisible: !prev.alertVisible,
                    warningMessage: "Unit yang anda pilih sudah ada. Mohon periksa kembali.",
                }))
                return;
            }
        }
        this.props.onSetState((prevValue) => {
            const newState = [...prevValue.data.mutationUnits];
            newState[index] = {
                ...newState[index],
                saved: !newState[index].saved,
            };

            if (!this.validDetail(newState[index])) {
                return {
                    ...prevValue,
                    alertVisible: !prevValue.alertVisible,
                    warningMessage: "Ada field data yang perlu diisi atau tidak sesuai kriteria isian. Mohon periksa kembali.",
                }
            }

            return {
                ...prevValue,
                data: {
                    ...prevValue.data,
                    mutationUnits: newState,
                },
            };
        });
    };

    validDetail = (obj) => {
        const column = ["kodeVariant", "kodeWarna", "nosin", "noka"];
        for (const [key, data] of Object.entries(obj)) {
            if (column.includes(key) && R.or(R.isNil(data), !data, R.isEmpty(data))) {
                return false;
            }
        }

        return true;
    }

    handleDeleteRow = (index) => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            data: {
                ...prevValue.data,
                mutationUnits: prevValue.data.mutationUnits.filter((_, idx) => idx !== index),
            },
        }));
    };

    handleReject = (rowIndex) => {
        let obj = this.props.state.data.mutationUnits.filter((a, idx) => {
            if (idx === rowIndex) {
                a.status = a.status !== "REJECTED" ? "REJECTED" : a.scanned ? "RECEIVED" : "ONPROGRESS";
                a.checked = false;
            }
            return a;
        });
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            data: {
                ...prevValue.data,
                mutationUnits: obj,
            },
        }));
    }

    handleShowScanner = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            scannerVisible: !prevValue.scannerVisible,
        }));
    };

    handleScanQR = async (data) => {
        const request = {
            nameCategory: "UNIT",
            encryptBarcode: data[0].rawValue,
            kodeCabang: this.props.state.data.mutationSourceKodeCabang?.value,
            kodeLocator: this.props.state.data.mutationSourceKodeLocator?.value,
            trxType: this.props.mutasiKeluarTab ? "TRX_IN" : "TRX_OUT"
        }
        const response = await Api.create("NAGAMAS_TRANSACTION").findBarcodeUnitMutation(request);
        console.log(response);
        
        if (response.ok && !R.isNil(response.data.data) && !R.isEmpty(response.data.data)) {
            const data = response.data.data;
            const isAlreadyExist = this.props?.state?.data?.mutationUnits?.find(item => item.saved && item?.nosin === data.noSin)
            console.log(isAlreadyExist);
            
            
            if(this.props.mutasiKeluarTab && isAlreadyExist){
                this.props.onSetState((prev) => ({
                    ...prev,
                    alertVisible: !prev.alertVisible,
                    warningMessage: "Unit yang anda pilih sudah ada. Mohon periksa kembali.",
                }))
                this.handleShowScanner();
                return
            }
            if (this.props.state.data.mutationSourceKodeLocator?.value === data.kodeLocator) {
                let obj;
                if (this.props.mutasiKeluarTab) {
                    const variantValue = this.props.state.kodeVarianOptions.find((kv) =>
                        R.equals(kv.value, data.kodeVariant)
                    );
                    const warnaValue = this.props.state.warnaOptions.find((w) =>
                        R.equals(w.id, data.kodeWarna)
                    );
                    obj = {
                        nosin: data.noSin,
                        noka: data.noKa,
                        saved: true,
                        scanned: false,
                        status: "ONPROGRESS",
                        variantName: variantValue ? variantValue.namaVariant : "",
                        kodeVariant: variantValue ? {...variantValue} : null,
                        kodeWarna: warnaValue ? {value: warnaValue.id, label: warnaValue.namaWarnaKomersil} : null,
                    };
                } else {
                    obj = this.props.state.data.mutationUnits.filter((a, idx) => {
                        if (a.nosin === data.noSin) {
                            a.scanned = true;
                            a.checked = true;
                            a.status = "RECEIVED";
                        }
                        return a;
                    });
                }
                const mutationUnits = this.props.mutasiKeluarTab ? [...this.props.state.data.mutationUnits, obj] : obj
                this.props.onSetState((prevValue) => ({
                    ...prevValue,
                    data: {
                        ...prevValue.data,
                        mutationUnits: mutationUnits,
                    },
                }));
            }

        }
        this.handleShowScanner();
    };

    addUnitButton = () => {
        if (this.props.mutasiKeluarTab) {
            if (this.props.state.data.mutationStatus === "NEW" || this.props.state.activityType === ACTIVITY_TYPE.CREATE) {
                return (
                    <>
                        <SimpleButton
                            icon={<i className="fa fa-plus margin-right-10px"></i>}
                            text="Tambah"
                            secondary={this.props.buttonType == "delete" || this.props.buttonType == "preview"}
                            disabled={this.props.buttonType == "delete" || this.props.buttonType == "preview"}
                            onClick={this.handleAddUnit}
                        />
                    </>
                )
            } else {
                return null
            }
        }
    }

    addUnitDetailButton = (val, rowIndex) => {
        if (this.props.mutasiKeluarTab) {
            if (this.props.state.data.mutationStatus === "NEW" || this.props.state.activityType === ACTIVITY_TYPE.CREATE) {
                return (
                    <>
                        <FlexView vAlignContent="center">
                            <Button className="btnAct" onClick={() => this.handleSaveRow(rowIndex)} disabled={this.props.buttonType == "delete" || this.props.buttonType == "preview"}>
                                    <span
                                        style={{
                                            backgroundColor: "transparent",
                                            color: this.props.buttonType == "delete" || this.props.buttonType == "preview" ? "grey" : "red",
                                            fontSize: 20,
                                        }}
                                    >
                                      {!val ? <i className="fa fa-save"/> : <i className="fa fa-lw fa-pencil-alt"/>}
                                    </span>
                            </Button>
                            <Button className="btnAct margin-left-15px" onClick={() => this.handleDeleteRow(rowIndex)} disabled={this.props.buttonType == "delete" || this.props.buttonType == "preview"}>
                                <i
                                    className="fa fa-trash"
                                    style={{
                                        backgroundColor: "transparent",
                                        color: this.props.buttonType == "delete" || this.props.buttonType == "preview" ? "grey" : "red",
                                        fontSize: 20,
                                    }}
                                />
                            </Button>
                        </FlexView>
                    </>
                )
            } else {
                return (
                    <>
                        <FlexView vAlignContent="center">
                            <input
                                id="input_checkbox_qr"
                                type="checkbox"
                                disabled
                                style={{width: "15px", height: "15px"}}
                                checked={this.props.state.data.mutationUnits[rowIndex].checked}
                                onChange={() => this.handleChecked(rowIndex)}
                            />
                        </FlexView>
                    </>
                )
            }
        } else {
            if (this.props.state.data.mutationStatus === "PROCESSED" || this.props.state.activityType === ACTIVITY_TYPE.CREATE) {
                return (
                    <>
                        <FlexView vAlignContent="center">
                            <input
                                id="input_checkbox_qr"
                                type="checkbox"
                                disabled
                                style={{width: "15px", height: "15px"}}
                                checked={this.props.state.data.mutationUnits[rowIndex].checked}
                                onChange={() => this.handleChecked(rowIndex)}
                            />
                            <Button className="btnAct margin-left-15px"
                                    onClick={() => this.handleReject(rowIndex)} disabled={this.props.buttonType == "delete" || this.props.buttonType == "preview"}>
                                <span style={{ position: 'relative', fontSize: 20, display: 'inline-block' }}>
                                    <i
                                      className="fas fa-hand-paper"
                                      style={{
                                        color:
                                          this.props.state.data.mutationUnits[rowIndex].status === "REJECTED" || this.props.buttonType == "delete" || this.props.buttonType == "preview"
                                            ? "black"
                                            : "red",
                                      }}
                                    />
                                    <i
                                      className="fas fa-slash"
                                      style={{
                                        position: 'absolute',
                                        top: 2.5,
                                        left: 0,
                                        color:
                                          this.props.state.data.mutationUnits[rowIndex].status === "REJECTED" || this.props.buttonType == "delete" || this.props.buttonType == "preview"
                                            ? "black"
                                            : "red",
                                      }}
                                    />
                                </span>
                            </Button>
                        </FlexView>
                    </>
                )
            }
        }
    }

    getWarnaOptions = (index) => {
        let {data, warnaOptions} = this.props.state;
        let kodeVariant = data.mutationUnits[index].kodeVariant?.value;
        if (kodeVariant) {
            return warnaOptions.filter(w => w.kodeVariant === kodeVariant).map(w => mapToObjectDDL(w.namaWarnaKomersil, w.id));
        }
        return warnaOptions.map(w => mapToObjectDDL(w.namaWarnaKomersil, w.id));
    }

    checkUnitOnLocator = async ({value}) => {
      this.props.onSetState((prev) => ({ ...prev, loading: true }));
      const res = await Api.create("NAGAMAS_TRANSACTION").getUnitList({
        kodeLocator: this.props.state.data.mutationSourceKodeLocator.value,
        kodeVariant: value,
        kodeWarna: null,
        unitStatus: "IN_STOCK",
        noSin: [],
        kodeCabang: this.props.state.data.mutationSourceKodeCabang?.value,
      });
      this.props.onSetState((prev) => ({ ...prev, loading: false }));
      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        if (!res.data.data.listUnit || res.data.data.listUnit?.length === 0) {
          this.setState({ alertVariantDoesntExist: true });
          this.props.onSetState((prev) => ({
            ...prev,
            alertInformation: {
            error: true,
            content: (
                <p>
                  Item tidak terdapat pada Lokasi gudang. Mohon dicek kembali!
                </p>
              ),
            },
          }));
        }
      }
    };

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        return (
            <>
                <FlexView vAlignContent="center" className="margin-bottom-10px" style={{gap: "10px"}}>
                    <h4>UNIT:</h4>
                    {this.addUnitButton()}
                    <Button
                        type="button"
                        className="btn"
                        style={{borderRadius: "50%"}}
                        disabled={
                            this.props.mutasiKeluarTab ?
                                !(this.props.state.data.mutationStatus === "NEW" || this.props.state.activityType === ACTIVITY_TYPE.CREATE) || this.props.buttonType == "delete" || this.props.buttonType == "preview" :
                                !(this.props.state.data.mutationStatus === "PROCESSED" || this.props.state.activityType === ACTIVITY_TYPE.CREATE) || this.props.buttonType == "delete" || this.props.buttonType == "preview"
                        }
                        onClick={() => this.addUnitViaScanner()}
                    >
            <span>
              <i className="fa fa-qrcode"></i>
            </span>
                    </Button>
                </FlexView>
                <SimpleDataTable
                    key={`${this.props.state.data.mutationUnits?.length}-${this.state.pagination.page}`}
                    data={this.props.state.data.mutationUnits}
                    columns={this.tableColumns}
                    toCount={this.props.state.data.mutationUnits?.length}
                    rowsPerPage={this.state.pagination.limit}
                    page={this.state.pagination.page - 1}
                    options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
                />
                {this.state.scannerVisible && (
                    <SimpleModal
                        title={"Scan QR Here"}
                        styles={{width: "40%"}}
                        visible={this.state.scannerVisible}
                        onClickClose={this.handleShowScanner}
                        content={
                            <Scanner
                                onScan={this.handleScanQR}
                                constraints={{
                                    height: {ideal: 720},
                                    video: {
                                        facingMode: {exact: "environment"},
                                        height: {ideal: 720}
                                    },
                                }}
                            />
                        }
                    />
                )}
                {this.state.noLocator && (
                    <SimpleModal
                        title={"No Locator Detected"}
                        styles={{width: "40%"}}
                        visible={this.state.noLocator}
                        onClickClose={this.handleTriggerNoLocator}
                        content={"No Locator Detected"}
                    />
                )}
                {this.state.pilihUnit && (
                    <MutasiBarangDetailPilihUnit
                        state={this.props.state}
                        index={this.state.indexUnit}
                        visible={this.state.pilihUnit}
                        isSingleSelectUnit={this.state.isSingleSelectUnit}
                        onClickClose={this.handlePilihUnit}
                        onSubmit={this.handleChosenUnit}
                    />
                )
                }
            </>
        );
    }
}

export default MutasiBarangDetailTabUnit;
